'use strict';

angular.module('app').filter('GetColorInterpolation', () => {
    const GetRangeColor = (() => {
        const ranges = [
            { range: [0, 24], color: '#c8d969' },
            { range: [24], color: '#e32525' },
        ];

        return (hours) => {
            const find = ranges.find((o) =>
                o.range.length > 1 ? hours > o.range[0] && hours <= o.range[1] : hours > o.range[0]
            );

            return find ? find.color : '#00000000';
        };
    })();

    const GetBlendings = (() => {
        const Colors = {
            Red: { R: 255, G: 0, B: 0 },
            Yellow: { R: 255, G: 255, B: 0 },
            Lime: { R: 59, G: 185, B: 58 },
        };

        const GetColorByHours = (hours) => {
            const percentage = Math.abs(100 * ((hours > 200 ? 200 : hours) / 200) - 100);

            return GetBlendedColor(percentage);
        };

        const Linear = (d1, d2, fraction) => {
            return d1 + (d2 - d1) * fraction;
        };

        const Interpolate = (color1, color2, fraction) => {
            let r = Linear(color1.R, color2.R, fraction);
            const g = Linear(color1.G, color2.G, fraction);
            const b = Linear(color1.B, color2.B, fraction);

            return 'rgb(' + Math.round(r) + ',' + Math.round(g) + ',' + Math.round(b) + ')';
        };

        const GetBlendedColor = (percentage) => {
            if (percentage < 50) return Interpolate(Colors.Red, Colors.Yellow, percentage / 50.0);

            return Interpolate(Colors.Yellow, Colors.Lime, (percentage - 50) / 50.0);
        };

        return GetColorByHours;
    })();

    return (date) => {
        let result = 200;

        if (date) {
            result = moment.duration(moment().diff(moment(date))).asHours();
        }

        return {
            'border-right': '3px solid ' + GetRangeColor(result),
        };
    };
});
